import { Field, Model } from 'serialize-ts';

@Model()
export class VolumePrice {
  @Field()
  netPrice: number;

  @Field()
  grossPrice: number;

  @Field()
  savePercentage: number;

  @Field()
  currency: string;

  @Field()
  quantity: number;
}
